// test2609
(2609 && 0);
